"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.closeValues = closeValues;
exports.expectCloseValues = expectCloseValues;
exports.getBigNumber = getBigNumber;
exports.getNumber = getNumber;
exports.revertPositive = revertPositive;
const bignumber_1 = require("@ethersproject/bignumber");
const tiny_invariant_1 = __importDefault(require("tiny-invariant"));
function closeValues(a, b, accuracy, logInfoIfFalse = '') {
    if (accuracy === 0)
        return a === b;
    if (Math.abs(a) < 1 / accuracy)
        return Math.abs(a - b) <= 10;
    if (Math.abs(b) < 1 / accuracy)
        return Math.abs(a - b) <= 10;
    const res = Math.abs(a / b - 1) < accuracy;
    if (!res && logInfoIfFalse)
        console.log('Expected close: ', a, b, accuracy, logInfoIfFalse);
    return res;
}
function expectCloseValues(v1, v2, precision, description = '', additionalInfo = '') {
    const a = typeof v1 == 'number' ? v1 : Number.parseFloat(v1.toString());
    const b = typeof v2 == 'number' ? v2 : Number.parseFloat(v2.toString());
    const res = closeValues(a, b, precision);
    if (!res) {
        console.log('Close values expectation failed:', description);
        console.log('v1 =', a);
        console.log('v2 =', b);
        console.log('precision =', Math.abs(a / b - 1), ', expected <', precision);
        if (additionalInfo !== '')
            console.log(additionalInfo);
    }
    (0, tiny_invariant_1.default)(res, 'close values');
    return res;
}
function getBigNumber(value) {
    const v = Math.abs(value);
    if (v < Number.MAX_SAFE_INTEGER)
        return bignumber_1.BigNumber.from(Math.round(value));
    const exp = Math.floor(Math.log(v) / Math.LN2);
    (0, tiny_invariant_1.default)(exp >= 51, 'Internal Error 314');
    const shift = exp - 51;
    const mant = Math.round(v / 2 ** shift);
    const res = bignumber_1.BigNumber.from(mant).mul(bignumber_1.BigNumber.from(2).pow(shift));
    return value > 0 ? res : res.mul(-1);
}
function getNumber(value) {
    return Number.parseFloat(value.toString());
}
function revertPositive(f, out, hint = 1) {
    try {
        if (out <= f(0))
            return 0;
        let min, max;
        if (f(hint) > out) {
            min = hint / 2;
            while (f(min) > out)
                min /= 2;
            max = min * 2;
        }
        else {
            max = hint * 2;
            while (f(max) < out)
                max *= 2;
            min = max / 2;
        }
        while (max / min - 1 > 1e-4) {
            const x0 = (min + max) / 2;
            const y0 = f(x0);
            if (out === y0)
                return x0;
            if (out < y0)
                max = x0;
            else
                min = x0;
        }
        return (min + max) / 2;
    }
    catch (e) {
        return 0;
    }
}
